export const tryCatch = (fn: () => void, errorMessage = `error executing: ${fn.name || fn}`): boolean => {
  try {
    fn();
    return true;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(errorMessage, e);
    return false;
  }
};
